export default __webpack_public_path__ + "static/media/p2.5bb59a23.jpg";